import React, { useState, useEffect, useCallback } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import DashboardHeader from "./dashboardHeader";
import DashBoardContainer from "../../components/containers/dashboardContainer";
import DragAndDrop from "../../components/dragAndDrop/file-upload.component";
import {
  submitIndividualApplication,
  updateIndividualApplication,
  fetchMembershipGrade,
  fetchApplicationTypes,
  deleteApplication,
  submitFirmApplication,
  updateFirmApplication,
  fetchIndividualApplicationReport,
  fetchFirmApplicationStatus as fetchFirmApplication,
  fetchDiscipline,
} from "../../actions";
import {
  SUBMIT_APPLICATION_ID,
  GENERATE_FILE_STRING_ID,
  SUBMIT_FIRM_APPLICATION_ID,
} from "../../store/loaders";
import Select from "react-select";
import LoadingSpinner from "../../components/loadingSpiner";
import PopupModel from "../../components/models/popupModel";
import ClassRequirements from "../../components/classRequirements";

const ApplicationChoosenClass = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const apiResponse = useSelector((state) => {
    const {
      loader,
      membershipGrade,
      applicationTypes,
      hasUpdatedIndividualApplication,
      fetchFile,
      firmApplication,
      hasDeletedApplication,
      individualApplicationReport,
      hasUpdatedFirm,
      firmApplicationSubmitted,
      submittedApplication,
      displine,
    } = state;
    const { grades } = membershipGrade;
    const { isLoading } = loader[SUBMIT_APPLICATION_ID] || { isLoading: false };
    const { application } = individualApplicationReport;
    const { types } = applicationTypes;
    const { message } = hasUpdatedIndividualApplication;
    const { file } = fetchFile;
    const fileLoader = loader[GENERATE_FILE_STRING_ID] || false;
    const { deleted } = hasDeletedApplication;
    const { updateId } = hasUpdatedFirm;
    const { response } = firmApplicationSubmitted;
    const firmLoader = loader[SUBMIT_FIRM_APPLICATION_ID] || false;
    const { displines } = displine;
    return {
      isLoading,
      application,
      grades,
      types,
      message,
      file,
      fileLoader,
      firmApplication,
      deleted,
      updateId,
      response,
      firmLoader,
      submittedApplication,
      displines,
    };
  });

  const [typeUser, setUserType] = useState("");
  const [requestId, setRequestId] = useState("");
  const [submitRequestId, setSubmitRequestId] = useState("");
  const [showPopupModel, setPopupModel] = useState(false);
  const [errors, setErrors] = useState({
    applicationType: false,
    membershipClass: false,
    discipline: false,
  });

  const actionLoader = apiResponse.isLoading;
  var currentUser = JSON.parse(localStorage.getItem("currentUser"));
  var steps = sessionStorage.getItem("steps");
  const appId = props.location.state && props.location.state.application?.id;

  const [applicationDetails, setApplicationDetails] = useState({
    step: 1,
    status: "not submitted",
    userId: currentUser.sub,
    firstname: currentUser.family_name,
    lastname: currentUser.given_name,
  });

  var membershipOptions;
  if (apiResponse.grades?.length > 0) {
    membershipOptions = apiResponse.grades.map((value) => {
      return { value: value.id, label: value.name };
    });
  }

  var applicationTypes;
  if (apiResponse.types?.length > 0) {
    applicationTypes = apiResponse.types.map((value) => {
      return { value: value.id, label: value.name };
    });
  }

  var disciplineArr;
  if (apiResponse.displines?.length > 0) {
    disciplineArr = apiResponse.displines.map((value, id) => {
      return { value: value.id, label: value.name };
    });
  }

  useEffect(() => {
    if (appId) {
      dispatch(fetchIndividualApplicationReport(appId));
      dispatch(fetchFirmApplication(appId));
    }
    dispatch(fetchMembershipGrade());
    dispatch(fetchApplicationTypes());
    dispatch(fetchDiscipline());
  }, []);

  useEffect(() => {
    if (apiResponse.deleted?.status) {
      dispatch(fetchIndividualApplicationReport(appId));
      dispatch(fetchFirmApplication(appId));
    }
    if (typeUser.label === "Firm Application") {
      setApplicationDetails({
        ...apiResponse.firmApplication?.application,
        applicantType: {
          id: typeUser.value,
          name: typeUser.label,
        },
      });
    } else {
      setApplicationDetails({
        ...apiResponse.application,
        applicantType: {
          id: typeUser.value,
          name: typeUser.label,
        },
        step: 1,
        status: "not submitted",
        userId: currentUser.sub,
        firstname: currentUser.family_name,
        lastname: currentUser.given_name,
      });
    }
  }, [apiResponse.deleted]);

  useEffect(() => {
    if (apiResponse.message === requestId) {
      history.push("/dashboard");
    }
  }, [apiResponse.message]);

  useEffect(() => {
    if (apiResponse.application && apiResponse.application?.id) {
      setApplicationDetails({
        ...apiResponse.application,
      });
      if (apiResponse.message === submitRequestId) {
        history.push({
          pathname: "/applicant/personal-details",
          state: {
            application: apiResponse.application,
          },
        });
      }
    }
  }, [apiResponse.application, apiResponse.message]);

  useEffect(() => {
    if (apiResponse.firmApplication?.application?.id) {
      setApplicationDetails({
        ...apiResponse.firmApplication?.application,
      });
      if (apiResponse.updateId === submitRequestId) {
        history.push({
          pathname: "/applicant/company/details",
          state: {
            application: apiResponse.firmApplication?.application,
          },
        });
      }
    }
  }, [apiResponse.firmApplication?.application, apiResponse.updateId]);

  useEffect(() => {
    if (apiResponse.response?.id) {
      dispatch(fetchFirmApplication(apiResponse.response?.id));
    }
    if (apiResponse.submittedApplication?.response?.id) {
      dispatch(
        fetchIndividualApplicationReport(
          apiResponse.submittedApplication?.response?.id
        )
      );
    }
  }, [apiResponse.response, apiResponse.submittedApplication?.response]);

  const handleSubmit = () => {
    const reqId = uuidv4();
    setSubmitRequestId(reqId);

    if (!applicationDetails.applicantType?.name) {
      setErrors({
        ...errors,
        applicationType: true,
      });
      // alert('Select application type')
      return;
    }
    if (
      !applicationDetails.membershipClassId?.name &&
      applicationDetails.applicantType?.name !== "Firm Application"
    ) {
      setErrors({
        ...errors,
        membershipClass: true,
      });
      // alert('Select membership class')
      return;
    }
    if (!applicationDetails.discipline?.name) {
      setErrors({
        ...errors,
        discipline: true,
      });
      // alert('Select a Discpline')
      return;
    }
    if(applicationDetails.applicantType?.name === 'Firm Application'){
        const sentItems = {
            ...applicationDetails,
            applicantType: {
                id: applicationDetails.applicantType?.id,
                name: applicationDetails.applicantType?.name
            },
            status: 'not submitted',
            userId: currentUser.sub,
            companyNames: 'firm'
        }
        if(apiResponse.firmApplication?.application?.id){
            dispatch(updateFirmApplication({
                data:{
                    ...sentItems
                },
                id: apiResponse.firmApplication?.application?.id,
                reqId: reqId
            }))
        }else{
            dispatch(submitFirmApplication({
                data:{
                    ...sentItems
                },
                reqId: reqId
            }))
        }
        return
    }
    if(apiResponse.application?.id){
    dispatch(updateIndividualApplication({
        data:{
            ...applicationDetails
        },
        id: apiResponse.application?.id,
        reqId:reqId
    }))
    }else{

        dispatch(submitIndividualApplication({
            data:{
                ...applicationDetails
            },
            reqId:reqId
        }))
    }
  };

  const handleSaveForLater = () => {
    const reqId = uuidv4();
    setRequestId(reqId);
    if (applicationDetails.applicantType?.name === "") {
      alert("Select application type");
      return;
    }
    if (
      applicationDetails.membershipClassId?.name === "" &&
      typeUser.label !== "Firm Application"
    ) {
      alert("membership cant be empty");
      return;
    }
    if (applicationDetails.applicantType?.name === "Firm Application") {
      const sentItems = {
        applicantType: {
          id: applicationDetails.applicantType?.id,
          name: applicationDetails.applicantType?.name,
        },
        status: "not submitted",
        userId: currentUser.sub,
        companyNames: "firm",
      };
      if (apiResponse.firmApplication?.application?.id) {
        dispatch(
          updateFirmApplication({
            data: {
              ...sentItems,
            },
            id: apiResponse.firmApplication?.application?.id,
            reqId: reqId,
          })
        );
      } else {
        dispatch(
          submitFirmApplication({
            data: {
              ...sentItems,
            },
            reqId: reqId,
          })
        );
      }
      history.push({
        pathname: "/dashboard",
      });
      return;
    }

    if (appId) {
      dispatch(
        updateIndividualApplication({
          data: {
            ...applicationDetails,
          },
          id: appId,
          reqId: reqId,
        })
      );
    } else {
      dispatch(
        submitIndividualApplication({
          data: {
            ...applicationDetails,
          },
          reqId: reqId,
        })
      );
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("Token");
  };

  const handleTypeChange = (text) => {
    setUserType(text);
    if (applicationDetails?.id) {
      setPopupModel(true);
    } else {
      setApplicationDetails({
        ...applicationDetails,
        applicantType: {
          id: text.value,
          name: text.label,
        },
      });
      sessionStorage.setItem("type", JSON.stringify(text));
    }
  };

  const handleConfirm = () => {
    dispatch(deleteApplication(applicationDetails.id));
    setPopupModel(false);
    setApplicationDetails({
      ...applicationDetails,
      applicantType: {
        id: typeUser.value,
        name: typeUser.label,
      },
    });
    sessionStorage.setItem("type", JSON.stringify(typeUser));
  };

  return apiResponse?.application || apiResponse.firmApplication ? (
    <div>
      <DashboardHeader activeStep={1} application={applicationDetails} />
      <DashBoardContainer
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        handleSaveForLater={handleSaveForLater}
        title="Next"
        middleTitle="Save for Later"
        isFetching={actionLoader || apiResponse.firmLoader?.isLoading}
        // disabled={actionLoader}
      >
        <div className="dashboard-content-title">
          <span className="dashboard-title">Choose application type</span>
          <div
            className="mt-2"
            style={{
              width: "40%",
              margin: "auto",
              border: errors.applicationType ? "1px solid red" : "",
              padding: errors.applicationType ? 0.2 : "",
            }}
          >
            <Select
              options={applicationTypes}
              onChange={(text) => {
                setErrors({
                  ...errors,
                  applicationType: false,
                });
                handleTypeChange(text);
              }}
              className="vertical-select-field"
              value={{
                value: applicationDetails.applicantType?.id,
                label: applicationDetails.applicantType?.name,
              }}
        
            />
          </div>
          {applicationDetails.applicantType?.name !== "Firm Application" ? (
            <div
              className="mt-2 d-flex"
              style={{
                width: "40%",
                margin: "auto",
                flexDirection: "column",
              }}
            >
              <span
                className="dashboard-title mt-2 mb-2"
                style={{ margin: "auto" }}
              >
                Choose membership class
              </span>
              <div
                style={{
                  border: errors.membershipClass ? "1px solid red" : "",
                  padding: errors.membershipClass ? 0.2 : "",
                }}
              >
                <Select
                  options={membershipOptions}
                  onChange={(text) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      membershipClassId: { id: text.value, name: text.label },
                    });
                    setErrors({
                      ...errors,
                      membershipClass: false,
                    });
                  }}
                  className="vertical-select-field"
                  value={{
                    value: applicationDetails.membershipClassId?.id,
                    label: applicationDetails.membershipClassId?.name,
                  }}
                />
              </div>
            </div>
          ) : null}
          <div
            className="mt-2 d-flex"
            style={{
              width: "40%",
              margin: "auto",
              flexDirection: "column",
            }}
          >
            <span
              className="dashboard-title mt-2 mb-2"
              style={{ margin: "auto" }}
            >
              Choose discipline
            </span>
            <div
              style={{
                border: errors.discipline ? "1px solid red" : "",
                padding: errors.discipline ? 0.2 : "",
              }}
            >
              <Select
                options={disciplineArr}
                onChange={(text) => {
                  setErrors({
                    ...errors,
                    discipline: false,
                  });
                  setApplicationDetails({
                    ...applicationDetails,
                    discipline: { id: text.value, name: text.label },
                  });
                }}
                className="vertical-select-field"
                style={{}}
                value={{
                  value: applicationDetails.discipline?.id,
                  label: applicationDetails.discipline?.name,
                }}
              />
            </div>
          </div>
        </div>
        <ClassRequirements
          type={applicationDetails.membershipClassId?.name}
          classId={applicationDetails.membershipClassId}
          isFirm={
            applicationDetails.applicantType?.name === "Firm Application"
              ? true
              : false
          }
        />
      </DashBoardContainer>
      <PopupModel
        show={showPopupModel}
        hide={() => setPopupModel(false)}
        content="All previous form information will be dropped. Are you sure?"
        btnText="OK"
        handleConfirm={handleConfirm}
      />
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "10%",
      }}
    >
      <LoadingSpinner color={"#1D834F"} />
    </div>
  );
};

export default ApplicationChoosenClass;
